<app-filters-minute-table
    (geFilter)="receiveFilterGeneral($event)"
    (estadoFilter)="receiveChangeEstadoFilter($event)"
></app-filters-minute-table>

<main>
    <app-minutes-table
      [recieveFilterName]="minutas"
      [booleanFlag]="booleanFlag"
      [booleanText]="booleanText"
      (changePagination)="receiveProviderPaginationChange($event)"
      (changeSorting)="receiveChangeSortingOrder($event)"
    ></app-minutes-table>
</main>
